import axiosInstance from "./index.services";

export async function DeleteGlimpsImage(id: number) {
  const response = await axiosInstance.patch(`/certificate/${id}/`, {
glimpse:""
}, {
    headers: { "Content-Type": "application/json" },
  });

  return response;
}

export async function SendCertificateEmail(id: number) {
  const response = await axiosInstance.post(`/certificate/${id}/send-only/`, {}, {
    headers: { "Content-Type": "application/json" },
  });
  return response;
}

export async function BulkCertificateImport(data:FormData){
  const response = await axiosInstance.post("/certificate/import-certificate/", data, {
    headers: { "Content-Type": "multipart/form-data"},
  });
  return response;
}

export async function BulkCertificateGenerate(data:FormData){
  const response = await axiosInstance.post("certificate/generate-certificate/", data, {
    headers: { "Content-Type": "multipart/form-data"},
  });
  return response;
}